import { ForbiddenError } from "./ForbiddenError";
import { NotFoundError } from "./NotFoundError";
import { UnauthorizedError } from "./UnauthorizedError";

export const errorMap: Record<number, Error> = {
  401: new UnauthorizedError("Please login"),
  403: new ForbiddenError("You do not have permission to perform this action"),
  404: new NotFoundError("Couldn't find that"),
};
